module.exports = __webpack_public_path__ + "static/media/Colombina.31dbeb76.png";